"use strict";

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _this = this;

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var Procedure_1 = require("./Procedure");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");

var entities_1 = require("../entities");
/**
 * @hidden
 */


exports.createTransferErc20Resolver = function (factories, tokenAddress, receiver) {
  return function () {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", factories.erc20TokenBalanceFactory.refresh(entities_1.Erc20TokenBalance.generateId({
                tokenAddress: tokenAddress,
                walletAddress: receiver
              })));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
};
/**
 * Procedure to transfer funds of an ERC20 token. If no token address is specified, it defaults to POLY
 */


var TransferErc20 =
/*#__PURE__*/
function (_Procedure_1$Procedur) {
  _inherits(TransferErc20, _Procedure_1$Procedur);

  function TransferErc20() {
    var _this2;

    _classCallCheck(this, TransferErc20);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(TransferErc20).apply(this, arguments));
    _this2.type = types_1.ProcedureType.TransferErc20;
    return _this2;
  }
  /**
   * Transfer an ERC20 token to another wallet. The token in question defaults to POLY if no address is supplied
      * Note that the procedure will fail if:
   * - The owner's token balance is less than the amount being transferred. The only exception to this is when transferring POLY on a testnet.
   * If that is the case, an extra transaction will be submitted to request the missing amount of tokens from the faucet
   * - The token being transferred is a Security Token. In that case, the corresponding Security Token transfer procedures should be used
   */


  _createClass(TransferErc20, [{
    key: "prepareTransactions",
    value: function prepareTransactions() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this$args, amount, receiver, tokenAddress, _this$context, contractWrappers, currentWallet, factories, ownerAddress, polyToken, securityTokenRegistry, token, isSecurityToken, _ref, _ref2, balance, address, polyTokenAddress, isTestnet;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$args = this.args, amount = _this$args.amount, receiver = _this$args.receiver, tokenAddress = _this$args.tokenAddress;
                _this$context = this.context, contractWrappers = _this$context.contractWrappers, currentWallet = _this$context.currentWallet, factories = _this$context.factories;
                _context2.next = 4;
                return currentWallet.address();

              case 4:
                ownerAddress = _context2.sent;
                polyToken = contractWrappers.polyToken, securityTokenRegistry = contractWrappers.securityTokenRegistry;

                if (!tokenAddress) {
                  _context2.next = 23;
                  break;
                }

                _context2.next = 9;
                return securityTokenRegistry.isSecurityToken({
                  securityTokenAddress: tokenAddress
                });

              case 9:
                isSecurityToken = _context2.sent;

                if (!isSecurityToken) {
                  _context2.next = 12;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "This address belongs to a Security Token. To transfer Security Tokens, use the functions in the Security Token's transfers or controller namespace"
                });

              case 12:
                _context2.prev = 12;
                _context2.next = 15;
                return contractWrappers.getERC20TokenWrapper({
                  address: tokenAddress
                });

              case 15:
                token = _context2.sent;
                _context2.next = 21;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](12);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: 'The supplied address does not correspond to an ERC20 token'
                });

              case 21:
                _context2.next = 24;
                break;

              case 23:
                token = polyToken;

              case 24:
                _context2.next = 26;
                return Promise.all([token.balanceOf({
                  owner: ownerAddress
                }), token.address(), polyToken.address(), contractWrappers.isTestnet()]);

              case 26:
                _ref = _context2.sent;
                _ref2 = _slicedToArray(_ref, 4);
                balance = _ref2[0];
                address = _ref2[1];
                polyTokenAddress = _ref2[2];
                isTestnet = _ref2[3];

                if (!balance.lt(amount)) {
                  _context2.next = 39;
                  break;
                }

                if (!(isTestnet && address.toUpperCase() === polyTokenAddress.toUpperCase())) {
                  _context2.next = 38;
                  break;
                }

                _context2.next = 36;
                return this.addTransaction(contractWrappers.getPolyTokens, {
                  tag: types_1.PolyTransactionTag.GetTokens
                })({
                  amount: amount.minus(balance).decimalPlaces(0, contract_wrappers_1.BigNumber.ROUND_HALF_UP),
                  address: ownerAddress
                });

              case 36:
                _context2.next = 39;
                break;

              case 38:
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: 'Not enough funds'
                });

              case 39:
                _context2.next = 41;
                return this.addTransaction(token.transfer, {
                  tag: types_1.PolyTransactionTag.TransferErc20,
                  resolvers: [exports.createTransferErc20Resolver(factories, address, receiver)]
                })({
                  to: receiver,
                  value: amount
                });

              case 41:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[12, 18]]);
      }));
    }
  }]);

  return TransferErc20;
}(Procedure_1.Procedure);

exports.TransferErc20 = TransferErc20;